import { Button } from '@mui/material';
import { BiSearchAlt } from 'react-icons/bi';

import { ButtonStyleSmall } from '@/components/Style/ButtonStyle';

type SearchButtonProps = {
  handleOnSubmit: () => void;
};

export const SearchButton = ({ handleOnSubmit }: SearchButtonProps) => {
  return (
    <Button
      type="button"
      variant="outlined"
      startIcon={<BiSearchAlt width={20} height={20} />}
      sx={ButtonStyleSmall}
      onClick={() => {
        handleOnSubmit();
      }}
    >
      検索
    </Button>
  );
};
